/*
 * Module for the multiple member update pay period view
*/

rs.module("content/employer/reporting/maintenance/multiplememberupdate/payperiods",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl, grid) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);
            var transmittalDetailKey = criteria.js(jsSelectors.transmittalDetailKey);
            var payPeriodKey = criteria.js(jsSelectors.payPeriodKey);
            var updateToken = criteria.js(jsSelectors.updateToken);
            var payPeriodNumber = criteria.js(jsSelectors.payPeriodNumber, { multiple: true });
            var payPeriodBeginDate = criteria.js(jsSelectors.payPeriodBeginDate, { multiple: true });
            var payPeriodEndDate = criteria.js(jsSelectors.payPeriodEndDate, { multiple: true });
            var planKeySelect = criteria.js(jsSelectors.planKeySelect);
            var payPeriodPayDate = criteria.js(jsSelectors.payPeriodPayDate, { multiple: true });
            var recordTypeSelect = criteria.js(jsSelectors.recordTypeSelect);
            var unitsWorkedInput = criteria.js(jsSelectors.unitsWorkedInput);
            var serviceCreditAmountInput = criteria.js(jsSelectors.serviceCreditAmountInput);
            var bargainingUnitSelect = criteria.js(jsSelectors.bargainingUnitSelect);
            var departmentSelect = criteria.js(jsSelectors.departmentSelect);
            var divisionSelect = criteria.js(jsSelectors.divisionSelect);
            var employmentSelect = criteria.js(jsSelectors.employmentSelect);
            var jobClassSelect = criteria.js(jsSelectors.jobClassSelect);
            var jobTitleSelect = criteria.js(jsSelectors.jobTitleSelect);
            var payGradeSelect = criteria.js(jsSelectors.payGradeSelect);
            var payGradeAmountInput = criteria.js(jsSelectors.payGradeAmountInput);
            var payStatusSelect = criteria.js(jsSelectors.payStatusSelect);
            var workPercentInput = criteria.js(jsSelectors.workPercentInput);
            var sickLeaveBalanceInput = criteria.js(jsSelectors.sickLeaveBalanceInput);
            var vacationBalanceInput = criteria.js(jsSelectors.vacationBalanceInput);
            var compensationBalanceInput = criteria.js(jsSelectors.compensationBalanceInput);
            var holidayBalanceInput = criteria.js(jsSelectors.holidayBalanceInput);
            var participationBeginDate = criteria.js(jsSelectors.participationBeginDate, { multiple: true });

            var formSubmission = $.js(jsSelectors.formSubmission);
            var cancelBtn = formSubmission.js(jsSelectors.cancelBtn);

            // Get select helpers for additional select list functionality.
            var planKeySelectHelper = selectHelper.getHelper(planKeySelect);
            var recordTypeSelectHelper = selectHelper.getHelper(recordTypeSelect);
            var bargainingUnitSelectHelper = selectHelper.getHelper(bargainingUnitSelect); 
            var departmentSelectHelper = selectHelper.getHelper(departmentSelect);
            var divisionSelectHelper = selectHelper.getHelper(divisionSelect);
            var employmentSelectHelper = selectHelper.getHelper(employmentSelect);
            var jobClassSelectHelper = selectHelper.getHelper(jobClassSelect);
            var jobTitleSelectHelper = selectHelper.getHelper(jobTitleSelect);
            var payGradeSelectHelper = selectHelper.getHelper(payGradeSelect);
            var payStatusSelectHelper = selectHelper.getHelper(payStatusSelect);

            // Handle grid selection change event.
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {
                    eventBanner.removeAllMessages();

                    var detailPayPeriodKey = values[0];
                    getFormData(detailPayPeriodKey);
                }

                _executeSelectionChanged = true;
            });

            // Handle cancel button click event.
            cancelBtn.on("click", function () {

                // Re-retrieve data to clear user changes.
                var detailPayPeriodKey = grid.selectedValues[0];
                getFormData(detailPayPeriodKey);
            });

            // Retrieve and populate form data with the given detail pay period key.
            function getFormData(detailPayPeriodKey) {
                $.get(
                    backendUrl,
                    { detailPayPeriodKey: detailPayPeriodKey }
                ).done(function (result) {

                    // Update form fields.
                    transmittalDetailKey.val(result.transmittalDetailKey);
                    payPeriodKey.val(result.payPeriodKey);
                    updateToken.val(result.updateToken);
                    payPeriodNumber.val(result.payPeriodNumber);
                    payPeriodBeginDate.val(result.payPeriodBeginDate);
                    payPeriodEndDate.val(result.payPeriodEndDate);
                    planKeySelectHelper.setValue(result.planKey);
                    payPeriodPayDate.val(result.payDate);
                    recordTypeSelectHelper.setValue(result.recordType);
                    unitsWorkedInput.val(result.unitsWorked);
                    serviceCreditAmountInput.val(result.serviceCreditAmount);
                    bargainingUnitSelectHelper.setValue(result.bargainingUnit);
                    departmentSelectHelper.setValue(result.department);
                    divisionSelectHelper.setValue(result.division);
                    employmentSelectHelper.setValue(result.employment);
                    jobClassSelectHelper.setValue(result.jobClass);
                    jobTitleSelectHelper.setValue(result.jobTitle);
                    payGradeSelectHelper.setValue(result.payGrade);
                    payGradeAmountInput.val(result.payGradeAmount);
                    payStatusSelectHelper.setValue(result.payStatus);
                    workPercentInput.val(result.workPercent);
                    sickLeaveBalanceInput.val(result.sickLeaveBalance);
                    vacationBalanceInput.val(result.vacationBalance);
                    compensationBalanceInput.val(result.compensationBalance);
                    holidayBalanceInput.val(result.holidayBalance);
                    participationBeginDate.val(result.participationBeginDate);
                });
            };
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);